<template>
  <Modal
    :title="titleModal"
    :show-modal="title === 'Create' || title === 'Edit'"
    class="h-[30rem] my-auto !w-[60rem] mx-auto"
    @close="$emit('on-close')"
  >
    <div class="flex flex-col mb-5">
      <div class="flex flex-row items-center">
        <label for="company">Company</label>
        <ChoiseCompany
          :options="companies"
          :data-company="formBankPayrun.selectedCompany"
          @selected:company="($event) => onSelectCompany($event)"
        />
      </div>
    </div>
    <div class="flex flex-col mb-5">
      <Input
        name="bankName"
        :label="'Bank Name'"
        :value="formBankPayrun.nameBank"
        :label-top="true"
        @input="($event) => onInputBankName($event)"
        placeholder="Input Bank Name"
        class="!mb-0"
        :input_class="v$.nameBank.$error ? '!outline-red-500' : null"
      />
      <span class="text-xs font-bold text-red-500" v-if="v$.nameBank.$error">{{
        messageErrorNameBank
      }}</span>
    </div>

    <div class="flex flex-col">
      <Input
        :label="'Bank Number'"
        :value="formBankPayrun.numberBank"
        :label-top="true"
        @input="($event) => onInputNumberBank($event)"
        class="!mb-0"
        placeholder="Input Bank Number"
        :input_class="v$.numberBank.$error ? '!outline-red-500' : null"
      />
      <span
        class="text-xs font-bold text-red-500"
        v-if="v$.numberBank.$error"
        >{{ messageErrorNumberBank }}</span
      >
    </div>

    <div class="flex flex-col gap-y-2" v-if="formBankPayrun.id !== null">
      <label for="status">Status : </label>
      <div class="flex">
        <SwitchButton :value="formBankPayrun.isActive" />
      </div>
    </div>

    <template v-slot:footer>
      <section class="flex flex-row justify-end gap-x-2 w-52">
        <Button
          class="w-24 py-2 text-white bg-gray-400 rounded-md"
          @click="$emit('on-close')"
        >
          Close
        </Button>
        <Button
          class="w-24 py-2 text-white bg-green-500 rounded-md"
          :disabled="disableSubmit"
          @click="$emit('submit')"
        >
          {{ formBankPayrun.id !== null ? "Update" : "Add" }}
        </Button>
      </section>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Input from "@/components/Input.vue";
import SwitchButton from "@/components/SwitchButton.vue";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import { useVuelidate } from "@vuelidate/core";
import { required, minLength, numeric } from "@vuelidate/validators";

export default {
  name: "ModalForm",
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    nameBank: {
      type: String,
      required: true,
    },
    numberBank: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    companies: {
      type: Array,
      required: true,
    },
    selectedCompany: {
      type: Object,
      required: true,
    },
  },
  components: {
    Modal,
    Input,
    SwitchButton,
    ChoiseCompany,
  },
  setup() {
    const v$ = useVuelidate();
    return {
      v$,
    };
  },
  data() {
    return {
      formBankPayrun: {
        id: null,
        nameBank: "",
        numberBank: "",
        isActive: false,
        selectedCompany: {},
      },
    };
  },
  validations() {
    return {
      nameBank: { required, minLengthValue: minLength(3) },
      numberBank: { required, numeric },
    };
  },
  watch: {
    id: {
      handler(value) {
        this.formBankPayrun.id = value;
      },
      deep: true,
    },
    nameBank: {
      handler(value) {
        this.formBankPayrun.nameBank = value;
      },
      deep: true,
    },
    numberBank: {
      handler(value) {
        this.formBankPayrun.numberBank = value;
      },
      deep: true,
    },
    isActive: {
      handler(value) {
        this.formBankPayrun.isActive = value;
      },
      deep: true,
    },
    selectedCompany: {
      handler(value) {
        this.formBankPayrun.selectedCompany = value;
      },
      deep: true,
    },
  },
  computed: {
    titleModal() {
      if (this.title === "Create") {
        return "Add Bank Payrun";
      } else if (this.title === "Edit") {
        return "Edit Bank Payrun";
      } else {
        return "";
      }
    },
    messageErrorNameBank() {
      if (this.v$.nameBank.required.$invalid) {
        return "Nama bank tidak boleh kosong";
      } else if (this.v$.nameBank.minLengthValue.$invalid) {
        return "Nama bank minimal harus 3 karakter";
      } else {
        return "";
      }
    },
    messageErrorNumberBank() {
      if (this.v$.numberBank.required.$invalid) {
        return "Nomor rekening tidak boleh kosong";
      } else if (this.v$.numberBank.numeric.$invalid) {
        return "Nomor rekening harus berupa huruf";
      } else {
        return "";
      }
    },
    disableSubmit() {
      if (this.v$.$invalid) {
        return true;
      }

      return false;
    },
  },
  methods: {
    onInputBankName($event) {
      this.$emit("update:nameBank", $event);
      this.v$.nameBank.$touch();
    },
    onInputNumberBank($event) {
      this.$emit("update:numberBank", $event);
      this.v$.numberBank.$touch();
    },
    onSelectCompany($event) {
      this.$emit("on-select-company", $event);
    },
  },
};
</script>
